import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/feature/rename/feature.rename.impact.query.gql"
import type {
  FeatureRenameImpactQuery,
  FeatureRenameImpactQueryVariables,
} from "@/v2-backoffice-client/feature/rename/__types__/feature.rename.impact.query"

type Options = QueryHookOptions<
  FeatureRenameImpactQuery,
  FeatureRenameImpactQueryVariables
>

export function useFeatureRenameImpactQuery(options?: Options) {
  return useQuery<FeatureRenameImpactQuery, FeatureRenameImpactQueryVariables>(
    query,
    options,
  )
}
